module.exports = __webpack_public_path__ + "img/ennetix-service-page-xome-status.f0bf0bf6.png";